import React from 'react';
import cx from 'classnames';
import { SearchV2 } from '../../../../icons/index.js';
import styles from './index.module.scss.js';

const Submit = ({
  className,
  style,
  onClick,
  isSearchable,
  size
}) => /* @__PURE__ */ React.createElement(
  "button",
  {
    type: "button",
    className: cx(styles.box, className, {
      [styles.searchable]: isSearchable,
      [styles[size]]: !!size
    }),
    style,
    onClick,
    "aria-label": "Search"
  },
  /* @__PURE__ */ React.createElement(SearchV2, null)
);

export { Submit };
//# sourceMappingURL=index.js.map
